import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    blockedPosition: string,
    onClose: () => void
}

const PairStatusChangeBlocked: React.FunctionComponent<IProps> = (props) => {
    return (
        <Modal bsSize='sm' backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header className='bg-danger' closeButton>
                <Modal.Title>Pair Status Change Blocked</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ marginBottom: 20 }}>Unfortunately, swap {props.blockedPosition} cannot be changed to transplanted because the charter cost is missing.</div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PairStatusChangeBlocked;